export function base64ToBlob(
    base64: string,
    contentType = 'application/octet-stream'
): Blob {
    const byteChars = atob(base64)
    const byteArray = new Uint8Array(byteChars.length)
    for (let i = 0; i < byteChars.length; i++) {
        byteArray[i] = byteChars.charCodeAt(i)
    }
    return new Blob([byteArray], { type: contentType })
}

export function triggerBlobDownload(blob: Blob, filename: string) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
}

export function downloadArtifactFromResult(result: any) {
    if (!result || !result.content_base64) return
    const contentType = result.content_type || 'application/octet-stream'
    const filename = result.filename || 'download.bin'
    const blob = base64ToBlob(result.content_base64, contentType)
    triggerBlobDownload(blob, filename)
}

export default downloadArtifactFromResult
